import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const HospitalLogo = ({ 
  size = 'large', 
  variant = 'header', 
  showText = true, 
  clickable = true,
  containerStyle = {}
}) => {
  const isHeader = variant === 'header';
  const isFooter = variant === 'footer';
  
  const logoStyles = {
    large: {
      width: { xs: 56, sm: 72, lg: 90 },
      height: { xs: 56, sm: 72, lg: 90 },
      mr: 0,
    },
    medium: {
      width: { xs: 48, sm: 64, lg: 80 },
      height: { xs: 48, sm: 64, lg: 80 },
    },
    small: {
      width: 40,
      height: 40,
      mr: 0,
    }
  };

  const currentSize = logoStyles[size];

  const logoContent = (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      ...containerStyle
    }}>
      <Box sx={{ 
        ...currentSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: isHeader ? '0px 2px 8px rgba(0,0,0,0.1)' : isFooter ? '0px 2px 6px rgba(0,0,0,0.1)' : '0px 4px 12px rgba(0,0,0,0.15)',
        background: 'white',
        borderRadius: '50%',
       
        overflow: 'hidden',
        flexShrink: 0,
        mr: isFooter ? 1.5 : { xs: 1.5, lg: 2 },
        p: isHeader ? { xs: 0.5, lg: 0.75 } : 0.5,
      }}>
        <img 
          src="/hih-logo.png" 
          alt="Hearts International Hospital Logo"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
      
      {showText && (
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" component="div" sx={{ 
            fontWeight: 700, 
            color: '#FFFFFF',
            lineHeight: 1.2,
            mb: -0.5,
            fontSize: isFooter ? { xs: '1rem', lg: '1.3rem' } : { xs: '1rem', sm: '1.1rem', lg: '1.5rem' },
            textShadow: isHeader ? '0 1px 3px rgba(0, 0, 0, 0.35)' : 'none',
          }}>
            Hearts International
          </Typography>
          <Typography variant="body2" sx={{ 
            color: '#ffffff',
            fontWeight: 500,
            fontSize: isFooter ? { xs: '0.8rem', lg: '1rem' } : { xs: '0.85rem', sm: '0.9rem', lg: '1.2rem' },
            textShadow: isHeader ? '0 1px 3px rgba(0, 0, 0, 0.35)' : 'none',
          }}>
            Hospital
          </Typography>
        </Box>
      )}
    </Box>
  );

  const wrapperStyles = {
    textDecoration: 'none',
    cursor: clickable ? 'pointer' : 'default',
    transition: 'all 0.3s ease',
    transform: 'translateY(0)',
    '&:hover': clickable && {
      transform: 'translateY(-2px)',
    },
    '&:active': clickable && {
      transform: 'translateY(0px)',
    }
  };

  if (clickable) {
    return (
      <Box component={RouterLink} to="/" sx={wrapperStyles}>
        {logoContent}
      </Box>
    );
  }

  return (
    <Box sx={wrapperStyles}>
      {logoContent}
    </Box>
  );
};

export default HospitalLogo;
